class CartSidebarRecommendations extends HTMLElement {
  constructor() {
    super();
    this._loaded = false;
  }

  connectedCallback() {
    if (this._loaded) return;
    this.loadRecommendations();
  }

  hasCarouselProducts() {
    return this.querySelector('.previewCartCarousel .product') != null;
  }

  getFallbackMarkup() {
    const template = this.querySelector('template[data-collection-fallback]');
    return template ? template.innerHTML.trim() : '';
  }

  applyFallback() {
    const markup = this.getFallbackMarkup();
    if (markup) {
      this.innerHTML = markup;
      this.initCarousel();
    }
  }

  loadRecommendations() {
    const url = this.dataset.url;
    if (!url) {
      this.applyFallback();
      return;
    }

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const section =
          doc.querySelector('#shopify-section-cart-sidebar-recommendations') ||
          doc.querySelector('[id^="shopify-section-"]');
        const carousel = section && section.querySelector('.previewCartCarousel');

        if (carousel && carousel.querySelector('.product')) {
          this.innerHTML = carousel.outerHTML;
          this._loaded = true;
          this.initCarousel();
          return;
        }

        this.applyFallback();
        this._loaded = true;
      })
      .catch(() => {
        this.applyFallback();
        this._loaded = true;
      });
  }

  initCarousel() {
    const container = this.matches('[data-product-collection-cart]')
      ? this
      : this.closest('[data-product-collection-cart]');

    document.dispatchEvent(
      new CustomEvent('cart-sidebar-recommendations:loaded', {
        bubbles: true,
        detail: { container: container || this },
      })
    );

    const carousel = this.querySelector('.previewCartCarousel.products-carousel');
    if (!carousel || typeof jQuery === 'undefined' || !jQuery.fn.slick) return;

    const $carousel = jQuery(carousel);
    if ($carousel.hasClass('slick-initialized')) {
      $carousel.slick('unslick');
    }

    const slides = carousel.querySelectorAll('.product').length;
    if (slides < 2) return;

    $carousel.slick({
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: carousel.dataset.itemDots === 'true',
      arrows: carousel.dataset.itemArrows === 'true',
    });
  }
}

if (!customElements.get('cart-sidebar-recommendations')) {
  customElements.define('cart-sidebar-recommendations', CartSidebarRecommendations);
}